import { extend } from 'sk-ui/lib/utils/util.js'

import terminalForm from './metaData/terminalForm'

export default {
  terminalCreate({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: terminalForm,
      props
    })
  },
  terminalEdit({ commit }, params) {
    const props = {
      title: '编辑用例',
      params: {
        id: params.rowIds[0]
      }
    }
    const editForm = extend(true, {}, terminalForm)
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  }
}
